import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { CRUD_CREATE, useCreate, useTranslate } from 'ra-core';

import { UserCreateForm } from './UserCreateForm';
import { AuthenticationLayout } from '../authentication';
import { useLayer7Notify } from '../useLayer7Notify';
import {
    getIsConfirmedAccount,
    setIsConfirmedAccount,
} from '../../lib/authentication/Confirmation/Confirmation';
export const UserCreate = props => {
    const translate = useTranslate();
    const classes = useStyles(props);
    const notify = useLayer7Notify();
    const isConfirmedAccount = getIsConfirmedAccount() || false;

    useEffect(() => {
        setTimeout(() => {
            if (isConfirmedAccount) {
                notify(
                    'resources.registrations.notifications.temporary_email_confirmation_success',
                    'info',
                    {},
                    false,
                    8000
                );
                setIsConfirmedAccount(false);
            }
        }, 2000);
    }, [isConfirmedAccount]);

    return (
        <div className={classes.container}>
            <div className={classes.columns}>
                {' '}
                <Typography
                    variant="h4"
                    color="textPrimary"
                    className={classes.title}
                >
                    {translate('resources.users.title')}
                </Typography>
                <UserCreateForm {...props} />
            </div>
        </div>
    );
};

export const UserCreatePage = props => (
    <AuthenticationLayout {...props}>
        <UserCreate />
    </AuthenticationLayout>
);

export const useUsercreate = () => {
    const [create, state] = useCreate('users');

    const usercreate = (data, { onSuccess, onFailure }) => {
        create(
            {
                payload: { data: data },
            },
            {
                action: CRUD_CREATE,
                onSuccess: () => {
                    onSuccess();
                },
                onFailure: error => {
                    onFailure(error);
                },
            }
        );
    };

    return [usercreate, state];
};

const useStyles = makeStyles(theme => ({
    title: {
        marginBottom: theme.spacing(6),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        flexGrow: 1,
        justifyContent: 'center',
    },
    columns: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(3),
        },
        '&:first-child': {
            minWidth: '380px',
            maxWidth: '30%',
            [theme.breakpoints.down('md')]: {
                maxWidth: '37%',
            },
            [theme.breakpoints.down('sm')]: {
                maxWidth: '100%',
                width: '100%',
            },
        },
    },
    errorIcon: {
        '& ion-icon': {
            color: '#FFCB00',
            height: '35px',
            width: '35px',
        },
    },
    confirmation: {
        marginTop: '15px',
    },
}));
